export const capitalize = (str) => {
  let strin = str.toLowerCase();
  if (typeof strin === "string") {
    return strin.charAt(0).toUpperCase() + strin.slice(1);
  } else {
    return "";
  }
};



// WEBPACK FOOTER //
// ./src/utils/capitalize.js